import React from 'react';

import { ArrowLink } from '../Links';
import RichTextConverter from '../RichText/RichTextConverter';
import * as styles from './SideScroll.module.scss';

export default function Snippets({ content, contentRef }) {
  return (
    <div className={styles.snippets} ref={contentRef}>
      {content.map((snippet, i) => (
        <div key={i} className={styles.snippet} data-analytics-component={'snippet'} data-analytics-id={snippet.title}>
          <img
            className={styles.logo}
            src={snippet.image?.file?.url}
            alt={snippet.image?.description || snippet.title}
          />
          <h4 className={styles.title}>{snippet.title}</h4>
          <RichTextConverter copy={snippet.body} />
          {snippet.linkUrl && snippet.linkLabel && (
            <ArrowLink url={snippet.linkUrl} className={styles.cta} label={snippet.linkLabel} hoverAnimation={true} />
          )}
        </div>
      ))}
    </div>
  );
}
